export function serializeObjToQueryParams(obj) {
    if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
        throw new Error(
            "serializeObjToQueryParams: Invalid argument. Expected an object."
        );
    }

    const params = [];

    for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null) {
            const value = obj[key];
            params.push(`${key}=${value}`);
        }
    }

    return `?${params.join("&")}`;
}
